/**
 * Helper for directory (DSS) search in the search contacts adapter.
 * Centralizes phone/extension detection and mapping directory users to contacts
 * with correct avatar handling (skip Graph avatar for DSS results to avoid 404).
 */

import { IGraphUser } from '../ms-teams-sdk/service/MsTeamsUserService';
import { transformGraphUser } from '../ms-teams-sdk/util/MsTeamsGraphUserUtil';
import { IWebexIntContact } from '../packages/adapter-interfaces/src';

export { isPhoneOrExtensionQuery } from '../ms-teams-sdk/service/MsTeamsUserService';

/**
 * Maps directory users (Graph or DSS) to adapter contacts.
 * DSS results: use DSS thumbnail (avatarUrl) when present, else fall back to Graph avatar.
 * Non-DSS directory users: use the provided fetchAvatar (Graph).
 */
export function transformDirectoryUsersToContacts(
  graphUsers: IGraphUser[],
  fetchAvatar: (userId: string) => Promise<string | undefined>
): IWebexIntContact[] {
  return (graphUsers ?? []).map((graphUser) => {
    const getAvatar =
      graphUser.fromDss && graphUser.avatarUrl
        ? () => Promise.resolve(graphUser.avatarUrl)
        : () => fetchAvatar(graphUser.id);
    return transformGraphUser(graphUser, getAvatar);
  });
}
